import React, {useEffect, useState} from "react";
import {Container} from "./styleMobile";
import {MenuBotton} from "./Menus/MenuBotton";
import {MenuHearder} from "./Menus/MenuHearder";
import {Home} from "./Home/Apresentacao";
import {Editais} from "./Editais/Editais";
import {Proposta} from "./Proposta/Proposta";
import {Licitacoes} from "./Licitacoes/Licitacoes";
import {Disputa} from "./Disputa/Disputa";
import {Monitoramento} from "./Monitoramento/Monitoramento";
import {Contato} from "./Contato/Contato";
import {Endereco} from "./Endereco/Endereco";
export const indexMobile = () => {
    return(
        <Container>
            <MenuHearder/>
            <MenuBotton/>
            <Home id={'home'}/>
            <Editais id={'prospeccao'}/>
            <Proposta id={'proposta'}/>
            <Licitacoes id={'licitacoes'}/>
            <Disputa id={'lances'}/>
            <Monitoramento id={'monitoramento'}/>
            <Contato id={'contato'}/>
            <Endereco id={'endereco'}/>
        </Container>
    )
}